import React from 'react';

import { Title, Button, useMantineTheme, Group, TextInput, Tooltip, ActionIcon } from '@mantine/core';
import { IconPlus, IconFilterOff } from '@tabler/icons-react';

const AthleteNotesFilters = ({
  searchTerm,
  setSearchTerm,
  openCreateNotes,
  permission = true,
}: {
  searchTerm: string;
  setSearchTerm: (value: string) => void;
  openCreateNotes: () => void;
  permission?: boolean;
}): JSX.Element => {
  const theme = useMantineTheme();

  return (
    <Group noWrap position='apart' p='xl' pb='xs'>
      <Title order={2} size='h2'>
        Notes
      </Title>

      <Group>
        <TextInput
          placeholder='Search Note'
          value={searchTerm}
          onChange={e => setSearchTerm(e.currentTarget.value)}
        />
        <Tooltip label='Clear filters'>
          <ActionIcon onClick={() => setSearchTerm('')}>
            <IconFilterOff />
          </ActionIcon>
        </Tooltip>
        <Button
          onClick={openCreateNotes}
          leftIcon={<IconPlus size={theme.fontSizes.md} />}
          disabled={!permission}
        >
          Add Note
        </Button>
      </Group>
    </Group>
  );
};

export default AthleteNotesFilters;
